import { useState } from "react";
import {
  Dialog,
  DialogContent,
  Button,
  Box,
  Paper,
  Stepper,
  StepLabel,
  Typography,
  Step,
  StepContent,
  TextField,
  Grid,
  IconButton,
} from "@mui/material";
import ThankYouCard from "../sections/@dashboard/Rating/ThankYouCard";
import CloseIcon from "@mui/icons-material/Close";

import api from "../Api";
import { BASE_URL } from "../Context/config";
import { toast } from "react-toastify";

export default function RatingDialog({
  serialKey,
  openDialog,
  onClose,
  onClick,
  labels,
}) {
  const initialSteps = [
    { label: "Provide the coupon please" },
    { label: labels?.skill_1 || "Quality of Work" },
    { label: labels?.skill_2 || "Cost-Effectiveness" },
    { label: labels?.skill_3 || "Timeliness" },
    { label: labels?.skill_4 || "Communication" },
    { label: labels?.skill_5 || "Agility" },
    { label: "Additional Comments" },
    { label: "Job Title" },
  ];

  const [dynamicSteps, setDynamicSteps] = useState(initialSteps);
  const [feedbackScores, setFeedbackScores] = useState(
    Array(initialSteps.length).fill(0)
  );
  const [Skill_1, setSkill_1] = useState(0);
  const [Skill_2, setSkill_2] = useState(0);
  const [Skill_3, setSkill_3] = useState(0);
  const [Skill_4, setSkill_4] = useState(0);
  const [Skill_5, setSkill_5] = useState(0);

  const [SerialKey, setSerialKey] = useState(serialKey ? serialKey : "");
  const [comment, setComment] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [isVerifyingCoupon, setIsVerifyingCoupon] = useState(false);

  const handleRatingClick = (score, step) => {
    const updatedFeedbackScores = [...feedbackScores];
    updatedFeedbackScores[step] = score;
    setFeedbackScores(updatedFeedbackScores);

    switch (step) {
      case 1:
        setSkill_1(score);
        break;
      case 2:
        setSkill_2(score);
        break;
      case 3:
        setSkill_3(score);
        break;
      case 4:
        setSkill_4(score);
        break;
      case 5:
        setSkill_5(score);
        break;
    }
  };

  const [activeStep, setActiveStep] = useState(SerialKey ? 1 : 0);

  const handleNextStep0 = async () => {
    if(!SerialKey) return;
    setIsVerifyingCoupon(true);
    try {
      const resp = await api.get(`${BASE_URL}/Coupons/GetCouponProviderSkills/${SerialKey}`);
      setDynamicSteps((prev) => {
        let ns = [...prev];
        ns[1].label = resp.data.skillLabel_1;
        ns[2].label = resp.data.skillLabel_2;
        ns[3].label = resp.data.skillLabel_3;
        ns[4].label = resp.data.skillLabel_4;
        ns[5].label = resp.data.skillLabel_5;
        return ns;
      });
      setActiveStep((prev) => prev + 1);
    } catch(err) {
      toast.error("Invalid coupon or error fetching details. Cannot proceed.", { autoClose: 3000 });
    }
    setIsVerifyingCoupon(false);
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleFinish = async () => {
    onClick({
      SerialKey,
      Skill_1,
      Skill_2,
      Skill_3,
      Skill_4,
      Skill_5,
      Comment: comment,
      JobTitle: jobTitle,
    });
    onClose();
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <Dialog open={openDialog} fullWidth maxWidth="sm">
        <DialogContent>
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 0,
              right: 0,
            }}
          >
            <CloseIcon />
          </IconButton>

          {activeStep === dynamicSteps.length ? (
            <Paper sx={{ p: 3, mt: 3, bgcolor: "grey.50012" }}>
              <ThankYouCard
                feedbackScores={[
                  Skill_1,
                  Skill_2,
                  Skill_3,
                  Skill_4,
                  Skill_5,
                ]}
              />
              <Button variant="contained" onClick={handleFinish}>
                Confirm
              </Button>
              <Button
                onClick={() => {
                  setActiveStep((prevActiveStep) => prevActiveStep - 1);
                }}
              >
                Back
              </Button>
            </Paper>
          ) : (
            <Stepper activeStep={activeStep} orientation="vertical">
              {dynamicSteps.map((step, index) => (
                <Step key={step.label}>
                  <StepLabel
                    optional={
                      index === dynamicSteps.length - 1 ? (
                        <Typography variant="caption">Last step</Typography>
                      ) : null
                    }
                  >
                    {step.label}
                  </StepLabel>
                  <StepContent>
                    {index === 0 ? (
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} sm={6}>
                          <TextField
                            label="Coupon Serial Key"
                            value={SerialKey}
                            onChange={(event) =>
                              setSerialKey(event.target.value)
                            }
                            fullWidth
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          container
                          justifyContent="flex-end"
                        >
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={handleNextStep0}
                              disabled={SerialKey === "" || isVerifyingCoupon}
                            >
                              {isVerifyingCoupon ? "Verifying..." : "Next"}
                            </Button>
                        </Grid>
                      </Grid>
                    ) : index === 6 ? (
                      <>
                        <Box sx={{ mt: 3 }}>
                          <Grid container spacing={2}>
                            <Grid item xs={12}>
                              <TextField
                                label="Additional Comments"
                                value={comment}
                                onChange={(event) =>
                                  setComment(event.target.value)
                                }
                                multiline
                                rows={4}
                                fullWidth
                                placeholder="Enter any additional comments about your experience (optional)"
                              />
                            </Grid>
                          </Grid>
                          <Box sx={{ mt: 2 }}>
                            <Button
                              onClick={() => {
                                setActiveStep(
                                  (prevActiveStep) => prevActiveStep - 1
                                );
                              }}
                            >
                              Back
                            </Button>
                            <Button
                              variant="contained"
                              onClick={() => {
                                setActiveStep(
                                  (prevActiveStep) => prevActiveStep + 1
                                );
                              }}
                              sx={{ ml: 1 }}
                            >
                              Next
                            </Button>
                          </Box>
                        </Box>
                      </>
                    ) : index === 7 ? (
                      <>
                        <Box sx={{ mt: 3 }}>
                          <Grid container spacing={2}>
                            <Grid item xs={12}>
                              <TextField
                                label="Job Title"
                                value={jobTitle}
                                onChange={(event) =>
                                  setJobTitle(event.target.value)
                                }
                                fullWidth
                                error={comment !== "" && jobTitle === ""}
                                helperText={
                                  comment !== "" && jobTitle === ""
                                    ? "Job title is required when providing comments"
                                    : ""
                                }
                                placeholder="Enter the job title (required if you provided comments)"
                              />
                            </Grid>
                          </Grid>
                          <Box sx={{ mt: 2 }}>
                            <Button
                              onClick={() => {
                                setActiveStep(
                                  (prevActiveStep) => prevActiveStep - 1
                                );
                              }}
                            >
                              Back
                            </Button>
                            <Button
                              variant="contained"
                              onClick={() => {
                                setActiveStep(
                                  (prevActiveStep) => prevActiveStep + 1
                                );
                              }}
                              disabled={comment !== "" && jobTitle === ""}
                              sx={{ ml: 1 }}
                            >
                              Next
                            </Button>
                          </Box>
                        </Box>
                      </>
                    ) : (
                      <>
                        <Box sx={{ mt: 3 }}>
                          <Grid container spacing={2}>
                            <Grid item xs={12}>
                              <Grid
                                container
                                justifyContent="center"
                                spacing={2}
                              >
                                {[1, 2, 3, 4, 5].map((score) => (
                                  <Grid item key={score}>
                                    <Button
                                      onClick={() => {
                                        handleRatingClick(score, activeStep);
                                        setActiveStep(
                                          (prevActiveStep) => prevActiveStep + 1
                                        );
                                      }}
                                      sx={{
                                        bgcolor:
                                          feedbackScores[activeStep] === score
                                            ? "primary.main"
                                            : "grey.300",
                                        color:
                                          feedbackScores[activeStep] === score
                                            ? "common.white"
                                            : "grey.800",
                                        "&:hover": {
                                          bgcolor: "primary.dark",
                                          color: "common.white",
                                        },
                                        borderRadius: "50%",
                                        minWidth: "50px",
                                        height: "50px",
                                        fontSize: "18px",
                                        fontWeight: 600,
                                      }}
                                    >
                                      {score}
                                    </Button>
                                  </Grid>
                                ))}
                              </Grid>
                            </Grid>
                          </Grid>
                          <Button
                            disabled={index === 0}
                            onClick={() => {
                              setActiveStep(
                                (prevActiveStep) => prevActiveStep - 1
                              );
                            }}
                          >
                            Back
                          </Button>
                        </Box>
                      </>
                    )}
                    {/* Remove the duplicate comment section */}
                  </StepContent>
                </Step>
              ))}
            </Stepper>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
